import * as React from 'react';
import { observer } from 'mobx-react-lite';

import useShowDataLogic from 'hooks/useShowDataLogic';
import NoDataTabs from 'components/common/NoDataTabs';
import ConditionSlider from './ConditionSlider';

import { Wrapper } from './styles';
import useStores from '../../hooks/useStore';

const ConditionSliders = observer(() => {
  const { UIStore } = useStores();

  const { predictionModel } = useShowDataLogic();

  const { conditionOptions, condition, loading } = UIStore;
  const isSelectedOption = (item) => {
    const filtered = condition.filter((option) => option.name === item.name);
    return filtered[0].rating;
  };

  if (loading) {
    return <p>Loading data</p>;
  }

  if (!predictionModel) {
    return <NoDataTabs />;
  }

  return (
    <Wrapper>
      {conditionOptions.map((item) => <ConditionSlider item={item} selected={isSelectedOption(item)} />)}
    </Wrapper>
  );
});

export default ConditionSliders;
